<template>
  <div>
    <button type="button" class="icon-btn" title="Add article" @click="showmodal">
      <feather type="plus" size="16"></feather>
    </button>
    <b-modal size="xl" :id="modalKey" title="Create article" @show="OnShowModal" @hide="clear" hide-footer
      no-close-on-esc no-close-on-backdrop>
      <div class="container-fluid">
        <b-modal :ref="'ArticleAddAlert' + id" title="Admin" @ok="close()" ok-only>
          <p class="my-4">{{ message }}</p>
        </b-modal>
        <div class="text-right">
          <b-form-checkbox switch size="s" v-model="form.status">Active</b-form-checkbox>
        </div>
        <div class="text-right">
          <b-form-checkbox switch size="s" v-model="form.list">as List</b-form-checkbox>
        </div>
        <hr>
        <div class="row">
          <div class="col-lg-9">
            <div class="row product-adding">
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationtitle" class="col-form-label pt-0">Title <span>*</span></label>
                    <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationtitle" type="text" v-model="form.title" required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label for="validationslug" class="col-form-label pt-0">Slug</label>
                  <input class="form-control" id="validationslug" type="text" v-model="form.slug" />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label class="col-form-label pt-0">Category <span>*</span></label>
                    <ValidationProvider name="Category" rules="required" v-slot="{ errors }">
                      <b-form-select v-model="form.category" :options="getCategories()"></b-form-select>
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-adding">
              <b-tabs content-class="mt-3">
                <b-tab title="Upload image" active>
                  <div class="col-xl-12">
                    <label class="col-form-label pt-0">Images</label>
                    <vue-dropzone id="dropzone" :options="ImagesOptions" class="dropzone digits" ref="dropzone"
                      :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-removed-file="fileRemoved"
                      @vdropzone-complete="uploadComplete"
                      @vdropzone-sending="sending" @vdropzone-error="uploadError">
                    </vue-dropzone>
                    <br />
                  </div>
                </b-tab>
                <b-tab title="Images link">
                  <div class="col-xl-12">
                    <div class="digital-add needs-validation">
                      <div class="form-group">
                        <label for="image1" class="col-form-label pt-0">Link image1</label>
                        <input class="form-control" id="image1" type="text" v-model="form.image1" required="" />
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
              <div class="col-xl-12">
                <label>Introduction</label>
                <vue-editor v-model="form.introduction"></vue-editor><br />
              </div>
              <div class="col-xl-12">
                <label class="col-form-label pt-0">Sections</label>
                <b-container class="solid">
                  <div v-for="(item, index) in form.article" :key="index">
                    <div class="product-adding">
                      <h2>{{ index + 1 }}</h2>
                      <div class="col-xl-12">
                        <div class="digital-add needs-validation">
                          <div class="form-group">
                            <label for="validationtitle" class="col-form-label pt-0">Title</label>
                            <input class="form-control" id="validationtitle" type="text" v-model="item.title" required="" />
                          </div>
                        </div>
                      </div>
                      <div class="product-adding">
                        <b-tabs content-class="mt-3">
                          <b-tab title="Upload image" active>
                            <div class="col-xl-12">
                              <label class="col-form-label pt-0">Images</label>
                              <vue-dropzone id='drop' :options="ImagesOptionsSection[index]" class="dropzone digits" ref="dropzone"
                                :index=index :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess"
                                v-on:vdropzone-removed-file="fileRemovedImageSection($event, index)"
                                @vdropzone-complete="(file, response) => uploadCompleteImageSection(file, index, response)"
                                @vdropzone-sending="sending" @vdropzone-error="uploadError">
                              </vue-dropzone>
                              <br />
                            </div>
                          </b-tab>
                          <b-tab title="Images link">
                            <div class="col-xl-12">
                              <div class="digital-add needs-validation">
                                <div class="form-group">
                                  <label for="image1" class="col-form-label pt-0">Link image1</label>
                                  <input class="form-control" id="image1" type="text" v-model="form.article[index].image" required="" />
                                </div>
                              </div>
                            </div>
                          </b-tab>
                        </b-tabs>  
                      </div>
                      <div class="col-xl-12">
                        <vue-editor v-model="item.section"></vue-editor><br />
                      </div>
                    </div>
                    <div class="row product-adding">
                      <div class="col-xl-12">
                        <div class="digital-add needs-validation">
                          <div class="form-group">
                            <div class="form-group">
                            <label for="ads" class="col-form-label pt-0">Ads script </label>
                            <b-form-textarea id="ads" v-model="item.ads" rows="3"
                              max-rows="6"></b-form-textarea>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row product-adding">
                      <div class="col-xl-8">
                        <div class="digital-add needs-validation">
                          <div class="form-group">
                            <label for="validationlink" class="col-form-label pt-0">Link</label>
                            <input class="form-control" id="validationlink" type="text" v-model="item.link" required="" />
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4">
                        <div class="digital-add needs-validation">
                          <div class="form-group">
                            <label for="validationrate" class="col-form-label pt-0">Rate</label>
                            <input class="form-control" id="validationtitle" type="text" v-model="item.rate" required="" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-12 text-right">
                      <button type="button" class="btn btn-default" @click="Addsection">
                        Add Section
                      </button>
                      <feather type="trash" stroke="#4050F6" stroke-width="" size="22px" fill="#4050F6"
                        @click="Delsection(index)"></feather>
                    </div>
                    <hr>
                  </div>
                </b-container>
              </div>
              <div class="col-xl-12">
                <label>Conclusion</label>
                <vue-editor v-model="form.conclusion"></vue-editor><br />
              </div>
            </div>
            <div class="row product-adding">
              <div class="col-xl-12">
                <label class="col-form-label pt-0">Reviews</label>
                <b-container class="solid">
                  <div class="col-xl-12 text-right">
                    <button type="button" class="btn btn-default" @click="AddReviews">
                      Add Review
                    </button>
                  </div>
                  <div v-for="(item, index) in form.reviews" :key="index">
                    <div class="pt-2 pb-2">
                      <hr>
                    </div>
                    <div class="row product-adding">
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="vname" class="col-form-label pt-0">Name </label>
                          <input class="form-control" id="vname" type="text" v-model="item.name" required="" />
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="vstate" class="col-form-label pt-0">State </label>
                          <input class="form-control" id="vstate" type="text" v-model="item.state" required="" />
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="vrating" class="col-form-label pt-0">Rate </label>
                          <input class="form-control" id="vrating" type="number" v-model="item.rating" required="" />
                        </div>
                      </div>
                      <div class="col-xl-3 pt-4">
                        <feather type="trash" stroke="#4050F6" stroke-width="" size="22px" fill="#4050F6"
                          @click="DelReview(index)"></feather>
                      </div>
                    </div>
                    <div class="row product-adding" style="padding-left: 20px;padding-right:20px;">
                      <label for="vreview" class="col-form-label pt-0">Review </label>
                      <b-form-textarea id="vreview" v-model="item.review" placeholder="Enter something..." rows="3"
                        max-rows="6"></b-form-textarea>
                    </div>
                  </div>
                </b-container>
              </div>
            </div>
            <hr>
            <div class="row product-adding">
              <div class="col-xl-8">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationmetatitle" class="col-form-label pt-0">Meta title </label>
                    <input class="form-control" id="validationmetatitle" type="text" v-model="form.metaTitle" />
                  </div>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationmetadescription" class="col-form-label pt-0">Meta description</label>
                    <input class="form-control" id="validationmetadescription" type="text" v-model="form.metaDescription" />
                  </div>
                </div>
              </div>
              <div class="col-xl-8">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationmetadescription" class="col-form-label pt-0">Meta keywords</label>
                    <input class="form-control" id="validationmetadescription" type="text" v-model="form.metaKeywords" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="solid" style="position:sticky; top:40px; margin-top: 28px;">
              <h4 class="text-center">Generate Article</h4>
              <hr>
                <div class="form-group">
                  <label for="vreview" class="col-form-label pt-0">Topic </label>
                        <b-form-textarea id="vreview" v-model="form.properties.topic" placeholder="Enter topic" rows="3"
                          max-rows="6"></b-form-textarea>
                </div>
                <div class="form-group">
                  <label for="validationstoreecurrency" class="col-form-label pt-0">Type</label>
                  <select class="custom-select" required="" v-model="form.properties.type">
                    <option value="Blog Post">Blog Post</option>
                    <option value="Informative Article">Informative Article</option>
                    <option value="News Article">News Article</option>
                    <option value="Opinion Piece">Opinion Piece</option>
                    <option value="Research Paper">Research Paper</option>
                    <option value="Product Review">Product Review</option>
                    <option value="Tutorial or How-To Guide">Tutorial or How-To Guide</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="validationstoreecurrency" class="col-form-label pt-0">Task</label>
                  <select class="custom-select" required="" v-model="form.properties.task">
                    <option value="Describe">Describe</option>
                    <option value="Explain">Explain</option>
                    <option value="Summarize">Summarize</option>
                    <option value="Compare and Contrast">Compare and Contrast</option>
                    <option value="Analyze">Analyze</option>
                    <option value="Persuade">Persuade</option>
                    <option value="Narrate">Narrate</option>
                    <option value="Insruct">Instruct</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="validationstoreecurrency" class="col-form-label pt-0">Tone</label>
                  <select class="custom-select" required="" v-model="form.properties.tone">
                    <option value="Formal">Formal</option>
                    <option value="Informative">Informative</option>
                    <option value="Casual">Casual</option>
                    <option value="Persuasive">Persuasive</option>
                    <option value="Narrative">Narrative</option>
                    <option value="Instruct">Instruct</option>
                    <option value="Educational">Educational</option>
                  </select>
                </div>
                <div class="form-group">
                <label for="validationstoreecurrency" class="col-form-label pt-0">Audience</label>
                  <select class="custom-select" required="" v-model="form.properties.audience">
                    <option value="General">General</option>
                    <option value="Specialized">Specialized</option>
                    <option value="Beginner">Beginner</option>
                    <option value="Intermediate">Intermediate</option>
                    <option value="Advenced">Advanced</option>
                  </select>
                </div>
              <hr>
              <button type="button" class="btn btn-success" @click="fetchData" :disabled="fetchingData">
                <span v-if="fetchingData" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Generate</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-12 pb-3">
        <div class="form-group mb-0">
          <div class="product-buttons text-right">
            <button type="button" class="btn btn-light mr-2" @click="back">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="save">
              Save
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
  
<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders, reportUploadError } from './../../../utils/imageUpload';
import { VueEditor } from "vue2-editor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VueAutoDropzone from 'vue-auto-dropzone';
import slug from "slug";
export default {
  components: { VueAutoDropzone, VueEditor },
  props: {
    id: String,
    categories: Array,
    host: String,
    language: String,
    // Suffixe distinct pour le second bouton « + » affiché sur mobile :
    // chaque instance possède alors son propre modal.
    modalSuffix: { type: String, default: "" }
  },
  data() {
    return {
      value: [],
      refId: null,
      form: {
        title: '',
        slug: '',
        introduction: '',
        article: [
          {
            title: '',
            images: [],
            section: '',
            ads:'',
            link: '',
            rate: '',
            image:''
          }],
        created: '',
        conclusion: '',
        images: [],
        status: true,
        category: '',
        metaTitle: '',
        metaDescription: '',
        metaKeywords: '',
        reviews: [],
        FirstImage: null,
        properties : {
          host:'',
          type:'Blog Post',
          task:'Explain',
          tone:'Informative',
          category:'',
          lang:'English',
          audience:'General',
          topic:''
        }
      },
      fetchingData:false,
      ImagesOptions: {
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {

        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      },
      ImagesOptionsSection: [{
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        params: [],
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.removeAllFiles();
          let images = this.options.params;
          images.forEach((e) => {
            let f = {
              size: '12300',
              name: e.filename,
              dataURL: e.src,
            };
            this.emit("addedfile", f);
            this.emit("thumbnail", f, f.dataURL);
            this.emit("complete", f);
            this.files.push(f);
          });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      }],
      message: "",
      error: 0,
      editor: ClassicEditor,
      imagePreview: null
    };
  },
  computed: {
    // Identifiant du modal, construit à partir de la boutique et d'un
    // éventuel suffixe : les versions bureau et mobile ont chacune le leur.
    modalKey() {
      return 'NewArticleModal' + this.id + this.modalSuffix;
    }
  },
  methods: {
    async fetchData() {
      try {
        this.fetchingData = true; // Start fetching data, so set fetchingData to true
        this.form.properties.host = this.host;
        this.form.properties.category=this.form.category;
        this.form.properties.lang = this.language;
        const response = await fetch('https://us-central1-blogai-6b08c.cloudfunctions.net/app/generatearticle/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            prompt: this.form.properties
          })
        });
        const data = await response.json();
        this.form.introduction = data.introduction;
        this.form.article[0].section = data.article;
        this.form.image1 = data.image;
        this.form.metaTitle = this.form.title.substring(0, 60);
        this.form.metaDescription = data.introduction.substring(0, 160);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.fetchingData = false; // Finished fetching data, so set fetchingData to false
      }
    },
    async save() {
      const now = firebase.firestore.Timestamp.now();
      this.error = 0;
      if ((this.form.title == "") && (this.form.images[0].src == "") && (this.form.category == "")) {
        this.message = "The Title field is required !";
        this.error = 1;
        this.$refs['ArticleAddAlert' + this.id].show();
        return false;
      }
      if (this.form.category == "") {
        this.message = "The Category field is required !";
        this.error = 1;
        this.$refs['ArticleAddAlert' + this.id].show();
        return false;
      }
      this.form.FirstImage = this.form.images.lenght > 0 ? this.form.images[0].src : this.form.image1 != '' ? this.form.image1 : '';
      this.form.id = slug(this.form.title, '-');
      this.form.created = now;
      console.log(this.id, ' - ', this.form.id);
      let ref = firebase.firestore().collection('Sites').doc(this.id).collection('Articles').doc(this.form.id);
      await ref.set(this.form);
      this.message = "Document successfully written!";
      this.error = 0;
      this.$refs['ArticleAddAlert' + this.id].show();
      this.$emit('ok', this.form);
    },
    close() {
      if (this.error == 0) this.$bvModal.hide(this.modalKey);
    },
    back() {
      this.$bvModal.hide(this.modalKey);
    },
    showmodal() {
      this.$bvModal.show(this.modalKey);
    },
    OnShowModal() {

    },
    clear() {
      this.form = {
        title: '',
        slug: '',
        introduction: '',
        article: [{
          title: '',
          images: [],
          section: '',
          link: '',
          rate: ''
        }],
        conclusion: '',
        images: [],
        status: true,
        category: '',
        metaTitle: '',
        metaDescription: '',
        metaKeywords: '',
        reviews: [],
        FirstImage: null,
        properties : {
          type:'Blog Post',
          task:'Explain',
          tone:'Informative',
          category:'',
          lang:'English',
          audience:'General'
        }
      };
      this.ImagesOptionsSection = [{
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        params: [],
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {

        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      }]
    },
    uploadComplete(file, response) {
      // L'API renvoie directement { url: '/uploads/...' } : l'image est
      // déjà stockée sur le serveur, plus besoin de renvoyer l'aperçu.
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.form.images.push({
          'image_id': this.$uuid.v1(),
          'src': data.url,
          'alt': "",
          'variant_id': [],
          'filename': this.$uuid.v1()
        });
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },
    uploadError(file, message) {
      reportUploadError(this, message);
    },
    sending(file, xhr, formData) {
      // Juste avant l'envoi : indique à l'API le dossier de stockage.
      formData.append('folder', 'blogs/' + this.host);
    },
    uploadSuccess() {

    },
    fileRemoved(file) {
      if (!this.form.images) return false;
      this.form.images = this.form.images.filter((e) => e.filename != file.name);
    },
    uploadCompleteImageSection(file, index, response) {
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.form.article[index].images.push({
          'src': data.url,
          'filename': this.$uuid.v1()
        });
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },
    fileRemovedImageSection(file, index) {
      if (index < this.$refs.dropzone.length - 1) {
        this.form.article[index].images = this.form.article[index].images.filter((e) => e.filename != file.name);
      }
    },
    removeAllFiles() {

    },
    getCategories() {
      if (!this.categories) return [];
      let categories = []
      this.categories.forEach((e) => {
        categories.push({ value: e.category, text: e.category });
      });
      //this.form.category=categories[0].value;
      return categories;
    },
    uploadImage() {
      // La première image est déjà stockée par l'API lors du dépôt dans
      // le dropzone : on réutilise simplement son URL comme image
      // principale de l'article.
      this.form.FirstImage = this.form.images.length ? this.form.images[0].src : null;
      let ref = firebase.firestore().collection('Sites').doc(this.id).collection('Articles');
      ref.doc(this.refId).set(this.form)
        .then((refDoc) => {

        })
        .catch((error) => {

        });
    },
    Addsection() {
      this.form.article.push(
        {
          title: '',
          images: [],
          section: '',
          link: '',
          rate: ''
        }
      );
      this.ImagesOptionsSection.push({
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFiles: 10,
        params: [],
        maxfilesexceeded: function (file) {

        },
        accept: function (file, done) {
          done();
        },
        init: function () {

        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: true,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
      });
    },
    Delsection(index) {
      if (index != 0) {
        this.form.article.splice(index, 1);
        this.ImagesOptionsSection.splice(index, 1)
      }
    },
    AddVariants() {
      this.form.variants.push(
        {
          option: '',
          value: []
        }
      );
    },
    AddReviews() {
      this.form.reviews.push(
        {
          name: '',
          state: '',
          rating: 5,
          review: ''
        }
      );
    },
    DelVariants(index) {
      this.form.variants.splice(index, 1);
      this.generateVariants();
    },
    DelReview(index) {
      this.form.reviews.splice(index, 1);
    },
    inputHandlers() {
      alert("event");
    },
    generateVariants() {
      var result = [];
      if (this.form.variants.length == 1) {
        for (let i = 0; i < this.form.variants[0].value.length; i++) {
          result.push({
            "option": this.form.variants[0].option,
            "value": this.form.variants[0].value[i],
            "price": this.form.price,
            "compare_at_price": this.form.compare_at_price,
            "default": "false"
          })
        }
      }
      if (this.form.variants.length == 2) {
        for (let i = 0; i < this.form.variants[0].value.length; i++) {
          for (let j = 0; j < this.form.variants[1].value.length; j++) {
            result.push({
              "option": [this.form.variants[0].option, this.form.variants[1].option],
              "value": [this.form.variants[0].value[i], this.form.variants[1].value[j]],
              "price": this.form.price,
              "compare_at_price": this.form.compare_at_price,
              "default": "false"
            })
          }
        }
      }
      this.form.TablePriceVariants = result;
    }
  }
};
</script>
<style lang="scss" scoped>
#box {
  width: 500px;
  height: 200px;
  border: 2px solid rgb(245, 220, 225);
  padding: 4px 6px;
  font: 16px "Lucida Grande", "Helvetica", "Arial", "sans-serif"
}

.solid {
  border: 2px dashed #ff8084;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
}

</style>